export default [
    {
        path: '/',
        name: 'dashboard',
        component: () =>
            import(
                /* webpackChunkName: "overview" */ '@/views/dashboard/Overview.vue'
            ),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/v2',
        name: 'dashboardv2',
        component: () =>
            import(
                /* webpackChunkName: "overview" */ '@/views/dashboard/Dashboard.vue'
            ),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/v3',
        name: 'dashboardv3',
        component: () =>
            import(
                /* webpackChunkName: "overview" */ '@/views/dashboard/DashboardV3.vue'
            ),
        meta: {
            requiresAuth: true,
        },
    },
]
